import 'vite/modulepreload-polyfill';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

import StoreMain from '../vendors/store-main';
import ProductMediaGallery from '../vendors/data-product-gallery';
import QuickView from '../vendors/data-quick-view';
import KlaviyoProductEnquiry from '../vendors/klaviyo-product-enquiry';
import KlaviyoContactForm from '../vendors/klaviyo-contact-form';
import SampleRequest from '../vendors/data-sample-request';
import GATracker from '../vendors/google-analytics-tracker';

Alpine.plugin(collapse);
Alpine.store('main', StoreMain);
Alpine.data('gaTracker', GATracker);
Alpine.data('productMediaGallery', ProductMediaGallery);
Alpine.data('quickView', QuickView);
Alpine.data('klaviyoProductEnquiry', KlaviyoProductEnquiry);
Alpine.data('klaviyoContactForm', KlaviyoContactForm);
Alpine.data('sampleRequest', SampleRequest);

window.Swiper = Swiper;
window.Alpine = Alpine;

Alpine.start();
